import {
	IsBoolean,
	IsDateString,
	IsEnum,
	IsNotEmpty,
	IsNumber,
	IsObject,
	IsOptional,
	IsString,
	IsUUID,
} from 'class-validator';
import { EventStatus } from '../../enums/event-status.enum';
import { EventType } from '../../enums/event-type.enum';
import { Type } from 'class-transformer';

export class CreateEventDto {
	@IsString()
	@IsNotEmpty()
	title: string;

	@IsOptional()
	@IsString()
	description?: string;

	@IsString()
	@IsNotEmpty()
	category_id: string;

	@IsOptional()
	@IsEnum(EventStatus)
	status?: EventStatus;

	@IsOptional()
	@IsDateString()
	displayed_start_time?: string;

	@IsOptional()
	@IsDateString()
	opening_time?: string;

	@IsOptional()
	@IsDateString()
	end_date?: string;

	@IsOptional()
	@IsDateString()
	closing_date?: string;

	@IsOptional()
	@IsBoolean()
	is_private?: boolean;

	@IsOptional()
	@IsString()
	access_password?: string;

	@IsOptional()
	@IsBoolean()
	featured?: boolean;

	@IsOptional()
	@IsString()
	attached_category_games?: string;

	@IsOptional()
	@IsBoolean()
	is_odds_locked?: boolean;

	@IsOptional()
	@IsEnum(EventType)
	type?: EventType;

	@IsOptional()
	@IsString()
	img_parent_id?: string;

	@IsOptional()
	@IsObject()
	img_variants?: Record<string, string>;
}

export class UpdateEventDto {
	@IsUUID()
	@IsNotEmpty()
	id: string;

	@IsOptional()
	@IsString()
	title?: string;

	@IsOptional()
	@IsString()
	description?: string;

	@IsOptional()
	@IsString()
	category_id?: string;

	@IsOptional()
	@IsEnum(EventStatus)
	status?: EventStatus;

	@IsOptional()
	@IsBoolean()
	is_private?: boolean;

	@IsOptional()
	@IsString()
	access_password?: string;

	@IsOptional()
	@IsDateString()
	displayed_start_time?: string;

	@IsOptional()
	@IsDateString()
	opening_time?: string;

	@IsOptional()
	@IsDateString()
	end_date?: string;

	@IsOptional()
	@IsDateString()
	closing_date?: string;

	@IsOptional()
	@IsDateString()
	markets_open_time?: string;

	@IsOptional()
	@IsBoolean()
	has_multiple_lobbies?: boolean;

	@IsOptional()
	@IsBoolean()
	is_odds_locked?: boolean;

	@IsOptional()
	@IsEnum(EventType)
	type?: EventType;

	@IsOptional()
	@IsString()
	img_parent_id?: string | null;

	@IsOptional()
	@IsObject()
	img_variants?: Record<string, string> | null;

	@IsOptional()
	@IsBoolean()
	featured?: boolean;

	@IsOptional()
	@IsNumber()
	featured_order?: number | null;
}

export class JoinEventDto {
	@IsUUID()
	@IsNotEmpty()
	id: string;

	@IsOptional()
	@IsString()
	password?: string | null;
}

export class EventDto {
	id: string;
	title: string;
	type: string;
	status: string;
	is_private: boolean;
	category_id: string;
	description?: string | null;
	@Type(() => Date)
	displayed_start_time: Date;
	@Type(() => Date)
	end_date: Date;
	@Type(() => Date)
	opening_time?: Date | null;
	img_variants?: Record<string, string> | null;
	is_odds_locked?: boolean | null;
	has_multiple_lobbies: boolean;
	competition_type?: string | null;
	is_score_hidden?: boolean | null;
	featured?: boolean;
}
